import { graphql, useLazyLoadQuery } from 'react-relay';
import { usePrintTypeInfoQuery } from './__generated__/usePrintTypeInfoQuery.graphql';

// Hook to get information about print types
export const usePrintTypeInfo = () => {
    const data = useLazyLoadQuery<usePrintTypeInfoQuery>(
        graphql`
            query usePrintTypeInfoQuery {
                hasPalettePantoneCMYK
            }
        `,
        {},
        { fetchPolicy: 'store-or-network' }
    );

    return {
        hasPalettePantoneCMYK: data.hasPalettePantoneCMYK
    };
};
